var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-anchor',{ref:"v-anchor",attrs:{"items":_vm.getSortItems,"active-item":_vm.getActiveSort}})}
var staticRenderFns = []

export { render, staticRenderFns }